import React, { type FunctionComponent, type ReactNode, useState, createContext, type SetStateAction, type Dispatch } from 'react';
import type { ModalInfo } from '../../components/Modal/Modal.types';

export const ModalContext = createContext<{
  modalState: ModalInfo | null;
  setModalState: Dispatch<SetStateAction<ModalInfo | null>>;
  toggleOpen: () => void;
}>({
  modalState: null,
  setModalState: () => {
    return null;
  },
  toggleOpen: () => {},
});

interface ModalProviderProps {
  children: ReactNode;
}

export const ModalProvider: FunctionComponent<ModalProviderProps> = ({ children }) => {
  const [modalState, setModalState] = useState<ModalInfo | null>({ open: false, options: null, title: null, props: null, componentConstructor: null });
  return (
    <ModalContext.Provider
      value={{
        modalState,
        setModalState,
        toggleOpen: () => {
          setModalState((prev) => {
            return {
              open: !prev?.open,
              componentConstructor: prev?.componentConstructor,
              props: prev?.props,
              options: prev?.options,
              title: prev?.title,
            } as ModalInfo;
          });
        },
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};
